import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ExpeditionImport from '@app/pages/expedition/ExpeditionImport.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';

interface ComponentProps {
}

const ExpeditionImportPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();
  return (
    <ResponsiveLayout
      title={tr('ExpeditionImport.expeditionImportPageTitle', 'Import expedition')}
      oneOfPermission={[PermissionTypesEnum.PERMISSION_SHIPMENT_MANUALIMPORT]}
    >
      <ExpeditionImport />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(ExpeditionImportPage);
